var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 25.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#474747;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    className: "cls-1",
    d: "M21.1,16.9c-.1,0-.3,0-.4,0-.2,0-.3,0-.5,0-.9,0-1.7-.6-1.9-1.5l-2.1-7.8c-.9-3.5-4.1-6-7.8-6-.2,0-.5,0-.7,0,0-.2,0-.4,0-.6C7.4,.3,6.5-.2,5.7,0s-1.3,1.1-1.1,1.9c0,.2,.2,.4,.3,.6C1.4,4.2-.5,8.1,.5,11.9l2.1,7.8c.3,1-.3,2.1-1.3,2.4,0,0,0,0,0,0-.9,.2-1.4,1.1-1.2,2,.2,.7,.9,1.2,1.6,1.2,.1,0,.3,0,.4,0l6.6-1.8c.6,1,1.7,1.5,2.8,1.5,.3,0,.6,0,.9-.1,1.4-.4,2.4-1.6,2.5-3.1l6.6-1.8c.4-.1,.8-.4,1-.8,.2-.4,.3-.8,.2-1.3-.2-.7-.8-1.2-1.6-1.2ZM3.8,22.8c.2-.2,.3-.4,.4-.6,.5-.9,.7-2,.4-3l-2.1-7.8c-.4-1.6-.2-3.2,.6-4.6,.8-1.4,2.1-2.4,3.7-2.8,.5-.1,1-.2,1.6-.2,2.7,0,5.1,1.8,5.9,4.5l2.1,7.8c.3,1.3,1.3,2.3,2.5,2.7L3.8,22.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    className: "cls-1",
    d: "M16.9,5.2c.3,0,.5-.1,.7-.3l2.1-2.1c.4-.4,.4-1,0-1.4-.4-.4-1-.4-1.4,0l-2.1,2.1c-.4,.4-.4,1,0,1.4,0,0,0,0,0,0,.2,.2,.4,.3,.7,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    className: "cls-1",
    d: "M21.9,8.1h-2.9c-.6,0-1,.4-1.1,1,0,.6,.4,1,1,1.1,0,0,0,0,0,0h2.9c.6,0,1-.5,1-1h0c0-.6-.5-1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    className: "cls-1",
    d: "M18.4,6.4c.2,.4,.5,.6,.9,.6,.1,0,.3,0,.4,0l2.7-1.1c.5-.2,.7-.8,.5-1.3-.2-.5-.8-.7-1.3-.5l-2.7,1.1c-.5,.2-.7,.8-.5,1.3,0,0,0,0,0,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.a7ef8f87ab0d07808523eb62db2a9c5b.svg";
export { ForwardRef as ReactComponent };